import { getBetCalculations } from 'calculation';
import { IClientConfig } from "src/client-config/config";
import { BetTypeEnum } from "src/constants/enums/betType";
import { BetCalculationsEnum } from "src/constants/enums/betCalculations"
import { IBonusRule, ICurrencyConfig, IPartnerConfig } from 'src/constants/interfaces';
import { ISelection } from "src/constants/interfaces/bet";

export const getTotalWin = (
    config: IClientConfig,
    stake: number,
    events: ISelection[],
    betType: BetTypeEnum,
    systemCombinationCount: number,
    bonusRule?: IBonusRule[],
    partnerConfig?: IPartnerConfig,
    currencyConfig?: ICurrencyConfig) => {
    const {
        possibleWin,
        expressBonus,
        profitOrReturnTax,
    } = getBetCalculations([
        BetCalculationsEnum.Bonus,
        BetCalculationsEnum.PossibleWin,
        BetCalculationsEnum.TaxForReturnOrProfit
    ], {
        config,
        stake,
        events,
        betType,
        partnerConfig,
        bonusRule,
        systemCombinationCount,
        currencyConfig,
    })
    const totalWin = possibleWin + (expressBonus.amount || 0) - profitOrReturnTax;

    return totalWin
}
